import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import { Container, Row, Col, Collapse, NavbarToggler, Nav, NavItem, NavLink, Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import { api } from "../../config";
import Scrollspy from "react-scrollspy";

import Rating from "react-rating";
import { Fab, Action } from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';
import tiktok from "../../assets/images/tiktok.png";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay, Navigation } from "swiper";

import { resetMarketingState, getMarketing, } from "../../store/marketing/action";
import { getMarket, resetMarketState } from "../../store/market/action";

const LandingAds = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const [isSearch, setIsSearch] = useState(false);
    const { markets, loading, error, marketings, marketingLoadings } = useSelector((state) => ({
        markets: state.Market.markets,
        loading: state.Market.loading,
        error: state.Market.error,
        marketings: state.Marketing.marketings,
        marketingLoading: state.Marketing.loading,
    }));

    const [isOpenMenu, setisOpenMenu] = useState(false);
    const [navClass, setnavClass] = useState("");
    const [nav, setNav] = useState("All");
    const [logo, setLogo] = useState("");
    const [banner, setBanner] = useState("");
    const [bannerTitle, setBannerTitle] = useState("");
    const [bannerAward, setBannerAward] = useState([]);
    const [marketList, setMarketList] = useState([]);
    const [marketing, setMarketing] = useState({
        name: "",
        phone: "",
        email: "",
        image: "",
        social_media: {
            instagram: "",
            facebook: "",
            tiktok: "",
            youtube: "",
            twitter: "",
        },
    });
    const [marketingList, setMarketingList] = useState([]);
    const [productList, setProductList] = useState([]);
    const [productCategoryList, setProductCategoryList] = useState([]);
    const [reviewList, setReviewList] = useState([]);
    const [promoList, setPromoList] = useState([]);
    const [videoList, setVideoList] = useState([]);
    const [bannerList, setBannerList] = useState([]);
    const [priceListList, setPriceListList] = useState([]);

    useEffect(() => {
        if (!isSearch) {
            setIsSearch(true);
            dispatch(resetMarketState());
            dispatch(getMarket({ companyId: 1 }));
            dispatch(resetMarketingState());
            dispatch(getMarketing({ companyId: 1 }));
        }
    }, [dispatch, isSearch]);

    useEffect(() => {
        if (!isEmpty(markets) && !isEmpty(marketings)) {
            setMarketList(markets[0].campaign_detail);
            setMarketingList(marketings);
            setMarketing(marketings[0])
            let products = [];
            let reviews = [];
            let promos = [];
            let banners = [];
            let videos = [];
            let priceList = [];
            let categories = [];
            let bannerAwards = [];
            for (const data of markets[0].campaign_detail) {
                if (data.type === "Produk") {
                    products.push(data)
                    let obj = categories.find(o => o.category === data.category);
                    if (!obj) categories.push({ category: data.category })
                }
                if (data.type === "Review")
                    reviews.push(data)
                if (data.type === "Promo")
                    promos.push(data)
                if (data.type === "Banner") {
                    if (data.category === "logo")
                        setLogo(data.image);
                    else if (data.category === "award") {
                        for (const img of data.campaign_detail_file)
                            bannerAwards.push({ filename: img.filename });
                    }
                    else {
                        setBanner(data.image);
                        setBannerTitle(data.title);
                    }
                }
                if (data.type === "Video")
                    videos.push(data)
                if (data.type === "PriceList")
                    priceList.push(data)

            }
            setProductList(products);
            setProductCategoryList(categories);
            setReviewList(reviews);
            setPromoList(promos);
            setBannerList(banners);
            setVideoList(videos);
            setPriceListList(priceList);
            setBannerAward(bannerAwards)
        }
    }, [markets, marketings, logo, banner]);

    const toggle = () => setisOpenMenu(!isOpenMenu);

    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation, true);
    });

    const scrollNavigation = () => {
        var scrollup = document.documentElement.scrollTop;
        if (scrollup > 50) {
            setnavClass("is-sticky");
        } else {
            setnavClass("");
        }
    }
    const toTop = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };

    document.title = "Pesona Kahuripan";
    return (
        <React.Fragment>
            <div className="layout-wrapper landing">
                <nav className={"navbar navbar-expand-lg navbar-landing navbar-light fixed-top " + navClass} id="navbar">
                    <Container>
                        <Link className="navbar-brand" to="/index">
                            <img src={logo && `${api.MEDIA_URL}/media/${logo}`} className="card-logo card-logo-dark" alt="logo dark" height="40" />
                            <img src={logo && `${api.MEDIA_URL}/media/${logo}`} className="card-logo card-logo-light" alt="logo light" height="40" />
                        </Link>

                        <NavbarToggler className="navbar-toggler py-0 fs-20 text-body" onClick={toggle} type="button" data-bs-toggle="collapse"
                            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                            aria-expanded="false" aria-label="Toggle navigation">
                            <i className="mdi mdi-menu"></i>
                        </NavbarToggler>

                        <Collapse className="navbar-collapse" id="navbarSupportedContent" >
                            <Scrollspy
                                offset={-18}
                                items={[
                                    "hero",
                                    "wallet",
                                    "marketplace",
                                    "categories",
                                    "creators",
                                ]}
                                currentClassName="active"
                                className="navbar-nav mx-auto mt-2 mt-lg-0"
                                id="navbar-example" >
                                {/* <li className="nav-item">
                                    <NavLink href="#hero">Home</NavLink>
                                </li>
                                {(productCategoryList || []).map((obj) => {
                                    return <li key={obj.category} className="nav-item">
                                        <NavLink href={`#${obj.category}`}>{obj.category}</NavLink>
                                    </li>

                                })} */}
                            </Scrollspy>
                            <div className="">
                                <button className="btn btn-success" onClick={() => {
                                    window.location.href = marketing && 'https://api.whatsapp.com/send/?phone=62' + marketing.phone + '&text=Hello+Marketing+Pesona Kahuripan+Saya+Butuh+Bantuan&type=phone_number&app_absent=0';
                                }}><i className="ri-whatsapp-line fs-15"></i> {marketing && marketing.name && marketing.name.toUpperCase()}</button>
                            </div>
                        </Collapse>
                    </Container>
                </nav>
                <section className="section nft-hero" id="hero" style={{ backgroundImage: `url(${api.MEDIA_URL}/media/${banner}-w-1280)` }}>
                    <div className="bg-overlay"></div>
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg={6} sm={8}>
                                <div className="text-center">
                                    <h1 className="display-4 fw-medium mb-4 lh-base text-white">{bannerTitle}</h1>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="section bg-light" id="marketplace">
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg={8}>
                                <div className="text-center mb-5">
                                    <h2 className="mb-3 fw-semibold lh-base">Eksplor Properti Terbaik Pesona Kahuripan</h2>
                                    <p className="text-muted mb-4">Rumah hunian komersil dan subsidi yang asri dan nyaman, dibangun dengan kualitas terbaik di lokasi yang sangat strategis.</p>
                                    <Nav pills className="nav-pills filter-btns justify-content-center" role="tablist">
                                        <NavItem role="presentation">
                                            <NavLink type="button" onClick={() => setNav("All")} className={nav === "All" ? " fw-medium active" : "fw-medium"}>All Items</NavLink>
                                        </NavItem>
                                        {(productCategoryList || []).map((obj) => {
                                            return <NavItem key={obj.category} role="presentation">
                                                <NavLink type="button" onClick={() => setNav(obj.category)} className={nav === obj.category ? " fw-medium active" : "fw-medium"}>{obj.category}</NavLink>
                                            </NavItem>

                                        })}
                                    </Nav>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            {((productList || []).filter(({ category }) => nav === category || nav === "All")).map((item, key) => (
                                <Col key={key} lg={4} className={"product-item " + item.isClass}>
                                    <div className="card explore-box card-animate">
                                        <div className="bookmark-icon position-absolute top-0 end-0 p-2">
                                            <button type="button" className="btn btn-icon active" data-bs-toggle="button" aria-pressed="true"><i className="mdi mdi-cards-heart fs-16"></i></button>
                                        </div>
                                        <div className="explore-place-bid-img">
                                            <img src={`${api.MEDIA_URL}/media/${item.image}-w-300`} alt="" className="card-img-top explore-img" />
                                            <div className="bg-overlay"></div>
                                            <div className="place-bid-btn">
                                                <Link to="#" className="btn btn-success"><i className="ri-auction-fill align-bottom me-1"></i> View Detail</Link>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <p className="fw-medium mb-0 float-end"><i className="mdi mdi-heart text-danger align-middle"></i> {item.likes} </p>
                                            <h5 className="mb-1"><Link to="/apps-nft-item-details">{item.title}</Link></h5>
                                            <p className="text-muted mb-0">{item.category}</p>
                                        </div>
                                        <div className="card-footer border-top border-top-dashed">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1 fs-14">
                                                    <i className="ri-price-tag-3-fill text-warning align-bottom me-1"></i> Highest: <span className="fw-medium">{item.highest}</span>
                                                </div>
                                                <h5 className="flex-shrink-0 fs-14 text-primary mb-0">{parseFloat(item.price, 2)}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </section>
                <section className="section" id="categories">
                    <Container fluid>
                        <Row className="justify-content-center">
                            <Col lg={5}>
                                <div className="text-center mb-5">
                                    <h2 className="mb-3 fw-semibold lh-base">Berbagai Penghargaan Pesona Kahuripan</h2>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <Swiper modules={[Navigation, Autoplay, Pagination]}
                                    slidesPerView={4}
                                    spaceBetween={30}
                                    navigation={{
                                        nextEl: ".swiper-button-next",
                                        prevEl: ".swiper-button-prev",
                                    }}
                                    pagination={{
                                        el: ".swiper-pagination",
                                        clickable: true,
                                    }}
                                    breakpoints={{
                                        640: {
                                            slidesPerView: 2,
                                            spaceBetween: 20,
                                        },
                                        768: {
                                            slidesPerView: 3,
                                            spaceBetween: 24,
                                        },
                                        1024: {
                                            slidesPerView: 4,
                                            spaceBetween: 30,
                                        },
                                    }}
                                    loop={true}
                                    autoplay={{ delay: 2500, disableOnInteraction: false }}
                                    className="mySwiper swiper mySwiper pb-4">
                                    <div className="swiper-wrapper">
                                        {(bannerAward || []).map((obj) => {
                                            return <SwiperSlide key={obj.filename}>
                                                <Card>
                                                    <CardBody>
                                                        <Row className="g-1 mb-3">
                                                            <img src={`${api.MEDIA_URL}/media/${obj.filename}`} alt="" className="img-fluid rounded" />
                                                        </Row>
                                                        {/* <Link to="#" className="float-end"> View All <i className="ri-arrow-right-line align-bottom"></i></Link>
                                                        <h5 className="mb-0 fs-16"><Link to="#">Artwork <span className="badge badge-soft-success">206</span></Link></h5> */}
                                                    </CardBody>
                                                </Card>
                                            </SwiperSlide>
                                        })}

                                    </div>
                                    <div className="swiper-pagination swiper-pagination-dark"></div>
                                </Swiper>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="section bg-light" id="marketing">
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg={8}>
                                <div className="justify-content-center text-center mb-3" >
                                    {marketing.image ? (
                                        <img
                                            src={`${api.MEDIA_URL}/media/${marketing.image}`} alt='' className='avatar-xl rounded-circle me-1'
                                        />
                                    ) : (
                                        <div className='avatar-xl me-1 d-inline-block'>
                                            <div className='avatar-title bg-soft-success text-success rounded-circle fs-36'>
                                                {marketing.name ? marketing.name.charAt(0) : "M"}
                                            </div>
                                        </div>
                                    )}
                                    <h2 className="mt-3 mb-1 fw-semibold lh-base">{marketing && marketing.name}</h2>
                                    <div id="basic-rater" dir="ltr" className="mb-3">
                                        <Rating
                                            initialRating={5}
                                            emptySymbol="mdi mdi-star-outline text-muted fs-22"
                                            fullSymbol="mdi mdi-star text-warning fs-22"
                                        />
                                    </div>
                                    <p className="text-muted mb-3">Hubungi marketing terbaik kami untuk informasi lebih lanjut bla.. bla.. bla</p>
                                    <button className="btn btn-lg btn-success" onClick={() => {
                                        window.location.href = marketing && 'https://api.whatsapp.com/send/?phone=62' + marketing.phone + '&text=Hello+Marketing+Pesona Kahuripan+Saya+Butuh+Bantuan&type=phone_number&app_absent=0';
                                    }}><i className="ri-whatsapp-line fs-15"></i> {marketing && marketing.name.toUpperCase()}</button>
                                </div>
                                <div className="text-center mt-sm-0">
                                    <ul className="list-inline mb-0 footer-social-link">
                                        <li className="list-inline-item">
                                            <Link to={marketing.social_media.facebook} className="avatar-sm d-block">
                                                <div className="avatar-title rounded-circle">
                                                    <i className="ri-facebook-fill fs-24"></i>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="list-inline-item">
                                            <Link to={marketing.social_media.instagram} className="avatar-sm d-block">
                                                <div className="avatar-title rounded-circle">
                                                    <i className="ri-instagram-fill fs-24"></i>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="list-inline-item">
                                            <Link to={marketing.social_media.tiktok} className="avatar-sm d-block">
                                                <div className="avatar-title rounded-circle">
                                                    <img style={{ width: "20px" }} src={tiktok} alt="t" />
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="list-inline-item">
                                            <Link to={marketing.social_media.youtube} className="avatar-sm d-block">
                                                <div className="avatar-title rounded-circle">
                                                    <i className="ri-youtube-fill fs-24"></i>
                                                </div>
                                            </Link>
                                        </li>
                                        <li className="list-inline-item">
                                            <Link to={marketing.social_media.twitter} className="avatar-sm d-block">
                                                <div className="avatar-title rounded-circle">
                                                    <i className="ri-twitter-line fs-24"></i>
                                                </div>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <p>Price List</p>
                                <Row>
                                    {priceListList.map((item, key) => (
                                        <Col key={key} xl={6} md={6}>
                                            <Card>
                                                <CardBody>
                                                    <div className="d-flex">
                                                        <div className="flex-shink-0">
                                                            <img src={`${api.MEDIA_URL}/media/${item.image}`} alt="" className="avatar-sm object-cover rounded" />
                                                        </div>
                                                        <div className="ms-3 flex-grow-1">
                                                            <h5 className="mb-1">{item.title}</h5>
                                                        </div>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="section">
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg={12}>
                                <div className="d-flex align-items-center mb-5">
                                    <h2 className="mb-0 fw-semibold lh-base flex-grow-1">Temukan Promo-Promo Menarik Kami</h2>
                                    <Link to="/apps-nft-explore" className="btn btn-primary">View All <i className="ri-arrow-right-line align-bottom"></i></Link>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            {(promoList || []).map((item, key) => (
                                <Col key={key} lg={4}>
                                    <Card className="explore-box card-animate border">
                                        <CardBody>
                                            <div className="d-flex align-items-center mb-3">
                                                <p className="mb-0 text-muted fs-13">{item.title}</p>
                                            </div>
                                            <div className="explore-place-bid-img overflow-hidden rounded">
                                                <img src={`${api.MEDIA_URL}/media/${item.image}-w-300`} alt="" className="explore-img w-100" />
                                                <div className="bg-overlay"></div>
                                                <div className="place-bid-btn">
                                                    <Link to="#" className="btn btn-success"><i className="ri-auction-fill align-bottom me-1"></i> Place Bid</Link>
                                                </div>
                                            </div>
                                            <div className="mt-3">
                                                <p className="fw-medium mb-0 float-end"><i className="mdi mdi-heart text-danger align-middle"></i> {item.likes} </p>
                                                <h5 className="text-success"><i className="mdi mdi-ethereum"></i> {item.price} </h5>
                                                <h6 className="fs-16 mb-0"><Link to="/apps-nft-item-details">{item.category}</Link></h6>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </section>
                <section className="py-5 bg-primary position-relative">
                    <div className="bg-overlay bg-overlay-pattern opacity-50"></div>
                    <Container>
                        <Row className="align-items-center gy-4">
                            <Col className="col-sm">
                                <div>
                                    <h4 className="text-white mb-0 fw-semibold">Tunggu Apa Lagi Segera Hubungi Salesman Terbaik Kami</h4>
                                </div>
                            </Col>

                            <Col className="col-sm-auto">
                                <div>
                                    <button className="btn btn-success" onClick={() => {
                                        window.location.href = marketing && 'https://api.whatsapp.com/send/?phone=62' + marketing.phone + '&text=Hello+Marketing+Pesona Kahuripan+Saya+Butuh+Bantuan&type=phone_number&app_absent=0';
                                    }}><i className="ri-whatsapp-line fs-15"></i> {marketing && marketing.name && marketing.name.toUpperCase()}</button>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <footer className="custom-footer bg-dark py-5 position-relative">
                    <Container>
                        <Row>
                            <Col lg={4} className="mt-4">
                                <div>
                                    <div>
                                        <img src={logo && `${api.MEDIA_URL}/media/${logo}`} alt="logo light" height="50" />

                                    </div>
                                </div>
                            </Col>
                            <Col lg={7} className="ms-lg-auto">
                                <nav className={"navbar navbar-expand-lg navbar-landing" + navClass}>
                                    <Scrollspy
                                        offset={-18}
                                        items={[
                                            "hero",
                                            "wallet",
                                            "marketplace",
                                            "categories",
                                            "marketing",
                                        ]}
                                        currentClassName="active"
                                        className="navbar-nav mx-auto mt-2 mt-lg-0"
                                        id="navbar-example" >
                                        <li className="nav-item">
                                            <NavLink className="text-white" href="#hero">Home</NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink className="text-white" href="#marketplace">Daftar Properti</NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink className="text-white" href="#categories">Penghargaan</NavLink>
                                        </li>
                                        
                                        <li className="nav-item">
                                            <NavLink className="text-white" href="#marketing">Marketing</NavLink>
                                        </li>
                                    </Scrollspy>
                                </nav>
                            </Col>

                        </Row>
                    </Container>
                </footer>
            </div>
            <Fab
                mainButtonStyles={{ left: 0, bottom: 0, backgroundColor: '#1d8944', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}
                icon={<i className="ri-phone-fill fs-36"></i>}
                alwaysShowTitle={true}>
                <Action
                    style={{ backgroundColor: '#25D366', }}
                    onClick={() => {
                        window.location.href = marketing && 'https://api.whatsapp.com/send/?phone=62' + marketing.phone + '&text=Hello+Marketing+Pesona Kahuripan+Saya+Butuh+Bantuan&type=phone_number&app_absent=0';
                    }}
                    text={marketing && marketing.name}><i className="ri-whatsapp-line fs-36"></i></Action>
                <Action
                    style={{ backgroundColor: '#1877F2', }}
                    onClick={() => {
                        window.location.href = 'https://www.facebook.com/abdihomeid/';
                    }}><i className="ri-facebook-line fs-36"></i></Action>
                <Action
                    style={{ backgroundColor: '#E1306C', }}
                    onClick={() => {
                        window.location.href = 'https://www.instagram.com/abdihomeid/';
                    }}><i className="ri-instagram-line fs-36"></i></Action>
                <Action
                    style={{ backgroundColor: '#FF0000', }}
                    onClick={() => {
                        window.location.href = 'https://www.youtube.com/@abdihome3909';
                    }}><i className="ri-youtube-line fs-36"></i></Action>
                <Action
                    style={{ backgroundColor: '#FFFFFF', }}
                    onClick={() => {
                        window.location.href = 'https://www.tiktok.com/@abdihome';
                    }}><i className="avatar-xs"><img className="avatar-xs" src={tiktok} alt="t" /></i></Action>
                <Action
                    style={{ backgroundColor: '#FFFFFF', }}
                    onClick={() => {
                        toTop()
                    }}><i className="ri-arrow-up-line fs-36 text-dark"></i></Action>

            </Fab>
        </React.Fragment>
    );
};

export default LandingAds;